module.exports = __webpack_public_path__ + "img/黄-选中@3x.06efa2be.png";